import React from "react";
import { useToaster } from "utils";
import { TaskForm, TaskFormValues, TaskResource } from "./TaskForm";
import { issuesApi } from "api/issuesApi";
import { PaziaModal } from "components/molecules";
import { ModalHeader } from "../Modals/ModalHeader";
import { queryClient } from "main";
import { ALL_ISSUES_QUERY, ARCHIVED_ISSUES_QUERY } from "api/hooks";
import { ModalPadding } from "../Modals/ModalPadding";

interface CreateTaskModalProps {
  onCloseRequest: () => void;
  resource: TaskResource | null;
}

export const CreateTaskModal = ({ onCloseRequest, resource }: CreateTaskModalProps) => {
  const { showSuccess, showError } = useToaster();

  const onSuccessSubmit = async (data: TaskFormValues) => {
    try {
      await issuesApi.create(data);
      showSuccess("Dodano zadanie");
      onCloseRequest();
    } catch (error) {
      showError("Nie udało się dodać zadania");
      console.error(error);
    } finally {
      onCloseRequest();
      queryClient.invalidateQueries({ queryKey: ALL_ISSUES_QUERY });
      queryClient.invalidateQueries({ queryKey: ARCHIVED_ISSUES_QUERY });
    }
  };

  return (
    <PaziaModal
      id="craete-task-modal"
      onCloseRequest={onCloseRequest}
      isOpen={resource != null}
      size="3xl"
      className="h-full md:h-3/4"
      // TODO dodac anuluj bo na mobilce sie nei da
    >
      <ModalPadding>
        <ModalHeader>Dodaj zadanie</ModalHeader>
        {resource && <TaskForm onSuccessSubmit={onSuccessSubmit} resource={resource} />}
      </ModalPadding>
    </PaziaModal>
  );
};
